import { Award, Medal, Trophy, CalendarHeart } from "lucide-react";

export const SUPPORTER_TIERS = [
  { key: "basic", name: "Basic", min: 0, blurb: "You're in the brotherhood" },
  { key: "silver", name: "Silver", min: 100, blurb: "A faithful first partner" },
  { key: "gold", name: "Gold", min: 500, blurb: "A pillar of the ministry" },
  { key: "platinum", name: "Platinum", min: 1000, blurb: "A cornerstone partner" },
];

export const TIER_PERKS = {
  basic: ["Full community & forum access", "Daily devotionals", "Prayer Wall"],
  silver: ["Recognition on your giving statements", "Priority event announcements"],
  gold: ["Early access to events", "Gold-only Prayer Circle", "Featured on the Supporter Wall"],
  platinum: ["A personal thank-you call", "Top billing on the Supporter Wall", "A direct line to the ministry team"],
};

const STYLES = {
  basic: "bg-rust text-white border-rust",
  silver: "bg-gradient-to-br from-[#d9dde2] to-[#f3f5f7] text-charcoal border-[#b8bfc7]",
  gold: "bg-gold text-navy border-gold",
  platinum: "bg-navy text-gold border-gold",
};

const SIZES = {
  sm: "px-2.5 py-1 text-[10px] gap-1.5",
  md: "px-3.5 py-1.5 text-xs gap-2",
  lg: "px-5 py-2.5 text-sm gap-2.5",
};

export function LevelBadge({ level = "basic", size = "md", className = "", ...props }) {
  const key = String(level).toLowerCase();
  const name = SUPPORTER_TIERS.find((t) => t.key === key)?.name || "Basic";
  const iconSize = size === "lg" ? 16 : size === "sm" ? 11 : 13;
  return (
    <span
      data-testid={`level-badge-${key}`}
      className={`inline-flex items-center font-mono uppercase tracking-[0.2em] border ${STYLES[key] || STYLES.basic} ${SIZES[size]} ${className}`}
      {...props}
    >
      <Award size={iconSize} strokeWidth={2} />
      {name} Supporter
    </span>
  );
}

export const MILESTONES = {
  gift_250: { name: "Faithful Giver", blurb: "$250 given", icon: Medal },
  gift_1000: { name: "Ministry Builder", blurb: "$1,000 given", icon: Trophy },
  year_1: { name: "One Year Faithful", blurb: "1 year of partnership", icon: CalendarHeart },
};

export function MilestoneBadge({ mkey, size = "md", className = "", ...props }) {
  const m = MILESTONES[mkey];
  if (!m) return null;
  const Icon = m.icon;
  const iconSize = size === "lg" ? 18 : size === "sm" ? 13 : 15;
  const pad = size === "lg" ? "px-5 py-2.5 text-sm gap-2.5" : size === "sm" ? "px-2.5 py-1 text-[10px] gap-1.5" : "px-3.5 py-1.5 text-xs gap-2";
  return (
    <span data-testid={`milestone-badge-${mkey}`}
      className={`inline-flex items-center font-mono uppercase tracking-[0.2em] border border-gold bg-gold/10 text-navy ${pad} ${className}`} {...props}>
      <Icon size={iconSize} strokeWidth={1.8} className="text-gold" />
      {m.name}
    </span>
  );
}
